import "./growth.css";
import './growth.css';
import React from 'react';
import { useLang } from '../../../i18n/context';

const recommendedBooks = [
  {
    id: 'book-candlestick',
    title: '《日本蜡烛图技术》',
    author: '史蒂夫·尼森',
    cover: 'https://covers.openlibrary.org/b/isbn/9780735201811-L.jpg',
  },
  {
    id: 'book-technical-analysis',
    title: '《金融市场技术分析》',
    author: '约翰·墨菲',
    cover: 'https://covers.openlibrary.org/b/isbn/9780735200661-L.jpg',
  },
  {
    id: 'book-trading-psychology',
    title: '《交易心理分析》',
    author: '马克·道格拉斯',
    cover: 'https://covers.openlibrary.org/b/isbn/9780735201446-L.jpg',
  },
];

export default function BookCards({ navigate }) {
  const { t } = useLang();

  return (
    <section className="hp-section">
      <h2 className="hp-section-title">{t('home.growthDocsTitle')}</h2>
      <p className="hp-section-desc">{t('home.growthDocsDesc')}</p>
      <div className="hp-books-grid">
        {recommendedBooks.map((book) => (
          <div className="hp-book-card" key={book.id} onClick={() => navigate('/books')}>
            <div className="hp-book-cover-wrap">
              <img className="hp-book-cover" src={book.cover} alt={`${book.title}封面`} loading="lazy" />
            </div>
            <div className="hp-book-card-title">{book.title}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
